// Microsoft Clarity – loaded once at app start, tracks all routes (SPA navigation is auto-detected)
const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || "";

// Tie the Clarity session to the logged-in user – mirrors posthog identifyUser in the
// Stockal app: custId (Stockal customerId) is the distinct ID so both tools match
export const identifyClarityUser = (user) => {
  const distinctId = user?.custId || user?.userId;
  if (!window.clarity || !distinctId) return;

  const friendlyName =
    user.name || [user.firstName, user.lastName].filter(Boolean).join(" ");

  window.clarity("identify", String(distinctId), undefined, undefined, friendlyName || undefined);

  const personProps = {
    platform: "web",
    "User Distinct ID": distinctId,
    "User ID": user.userId,
    "Account Status": user.status,
    "Current Step": user.currentStep,
    Country: user.country || user.countryCode,
  };
  Object.entries(personProps).forEach(([key, value]) => {
    window.clarity("set", key, String(value ?? "NA"));
  });
};

export const initClarity = () => {
  if (!CLARITY_PROJECT_ID || typeof window === "undefined" || window.clarity) return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);

  // Page refresh with an existing session – re-identify the stored user
  try {
    identifyClarityUser(JSON.parse(sessionStorage.getItem("userId")));
  } catch (error) {
    // no stored user
  }
};
